// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header-commonHeaderAdmin-HxV6x {
	position: fixed !important;
}

.Header-adminLayout-UkHJl {
	padding-top: 64px !important;
}

.Header-box-hmLxK h2 {
	font-size: 21px;
	font-weight: 600;
}

.Header-exportLink-k1Sbf {
	margin-bottom: -29px;
}

.Header-blockCenter-Kwex8 {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.Header-panelHeader-osu2u {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.Header-currencyselect-YcHY5 {
	width: 100%;
	margin-right: 0px;
}

.Header-panelHeader-osu2u {
	overflow: hidden;
	position: relative;
}

.Header-mar0-IZ_vp {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.Header-blockCenter-Kwex8 {
		padding: 0px;
	}

	.Header-panelHeader-osu2u {
		padding: 24px 5px;
	}
}

.Header-root-B1D_e {
	background: var(--background-primary);
}

.Header-container-vreYu {
	margin: 0 auto;
	padding: 0px;
	max-width: 100%;
	position: relative;
	background: var(--background-primary);
	border-bottom: 1px solid var(--primary-border);
	z-index: 10;
}

.Header-fixedHeader-xOE2l {
	position: fixed;
	width: 100%;
	left: 0px;
	right: 0px;
	height: auto;
	max-height: 100vh;
}

.Header-commonHeaderBorderLess-sZPyl {
	border: 0px;
	-webkit-box-shadow: none;
	        box-shadow: none;
}

.Header-brand-uP6rz {
	line-height: inherit;
	vertical-align: middle;
	text-decoration: none;
	height: auto;
	float: left;
	padding: 0px 19px;
	color: var(--primary-foreground);
	font-size: 24px;
	font-weight: normal;
}

.Header-brand-uP6rz:hover,
.Header-brand-uP6rz:focus {
	text-decoration: none;
	-webkit-backface-visibility: hidden !important;
	        backface-visibility: hidden !important;
}

.Header-navBarToggle-qaw67 {
	color: var(--primary-foreground);
	float: right;
	font-size: inherit;
	line-height: inherit;
	vertical-align: middle;
	border: 0px;
	border-radius: 0px;
	margin: 0px;
	padding: 0px 19px 0px 0px;
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	height: 81px;
	margin-right: 10px;
}

.Header-commonHeaderAdmin-HxV6x {
	background: #fff;
	border-width: 0px 0px 1px 0px;
	border-color: var(--primary-border);
	border-radius: 0px;
	min-height: 63px;
	line-height: 63px;
	width: 100%;
	-webkit-box-shadow: none;
	        box-shadow: none;
	margin-bottom: 0px;
	z-index: 1001;
}

.Header-navBarToggle-qaw67:hover,
.Header-navBarToggle-qaw67:focus,
.Header-navBarToggle-qaw67:hover:focus {
	background: none !important;
}

.Header-listHeaderFixed-ozGz6 {
	position: fixed;
	width: 100%;
	height: 100vh;
}

.Header-hamburgerIcon-KQAd4 {
	font-size: 20px;
	margin-top: 20px;
	float: right;
}

.Header-headerFlexBox-K2PAn {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	-webkit-box-pack: space-between;
	-ms-flex-pack: space-between;
	justify-content: space-between;
	-ms-flex-wrap: nowrap;
	    flex-wrap: nowrap;
	padding: 12px 12px 10px;
}

.Header-homeLogo-QQUBj {
	height: 60px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.Header-homeLogo-QQUBj img {
	width: auto;
	max-width: 160px;
	height: 100%;
	max-height: 60px !important;
	-o-object-fit: contain;
	   object-fit: contain;
	-o-object-position: left;
	   object-position: left;
}

@media screen and (max-width: 1199px) {
	.Header-mobileMenu-rhJeL {
		position: absolute;
		width: 100%;
		background: var(--background-primary);
		top: 0px;
		height: auto;
		z-index: 5;
		right: -100%;
		-webkit-transition: 0.5s;
		transition: 0.5s;
		height: 100vh;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;

	}

	.Header-menuOpen-I7CV0 {
		right: 0;
		-webkit-transition: 0.5s;
		transition: 0.5s;
		overflow-y: auto;
		overflow-x: hidden;
		-webkit-overflow-scrolling: touch;
		height: 100vh;
		padding-bottom: 100px;
	}

	.Header-closeColor-mXSsO {
		color: #0009;
		font-size: 36px;
		position: absolute;
		display: block;
		top: 3px;
		padding: 0;
		right: 22px;
		z-index: 8;
		cursor: pointer;
	}

	.Header-closeButtonPosition-wr3nK img {
		width: 15px;
		height: 15px;
	}

	.Header-closeButtonPosition-wr3nK {
		position: fixed;
		top: 0px;
		width: 100%;
		background: var(--background-primary);
		height: 50px;
		z-index: 6;
		overflow: hidden;
	}

	.Header-container-vreYu {
		z-index: 10;
	}

	.Header-innerPageHeader-gfSNO {
		border-bottom: 1px solid var(--primary-border);
	}
}

@media screen and (max-width: 991px) {
	.Header-breakPoint-dqTe7 {
		display: block;
	}

	.Header-homeLogo-QQUBj img {
		max-width: 100px;
	}
}

@media (max-width: 480px) and (min-width: 320px) {
	.Header-mobileMenu-rhJeL {
		padding-bottom: 80px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA;CACC,qCAAqC;AACtC;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,qCAAqC;CACrC,8CAA8C;CAC9C,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,WAAW;CACX,SAAS;CACT,UAAU;CACV,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,wBAAgB;SAAhB,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,sBAAsB;CACtB,qBAAqB;CACrB,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,gCAAgC;CAChC,eAAe;CACf,mBAAmB;AACpB;;AAEA;;CAEC,qBAAqB;CACrB,8CAAsC;SAAtC,sCAAsC;AACvC;;AAEA;CACC,gCAAgC;CAChC,YAAY;CACZ,kBAAkB;CAClB,oBAAoB;CACpB,sBAAsB;CACtB,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,yBAAyB;CACzB,mCAA2B;SAA3B,2BAA2B;CAC3B,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,6BAA6B;CAC7B,mCAAmC;CACnC,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;CACjB,WAAW;CACX,wBAAgB;SAAhB,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;AACd;;AAEA;;;CAGC,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,WAAW;CACX,aAAa;AACd;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,+BAA+B;CAC/B,4BAA4B;CAC5B,8BAA8B;CAC9B,qBAAiB;KAAjB,iBAAiB;CACjB,uBAAuB;AACxB;;AAEA;CACC,YAAY;CACZ,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,YAAY;CACZ,2BAA2B;CAC3B,sBAAmB;IAAnB,mBAAmB;CACnB,wBAAqB;IAArB,qBAAqB;AACtB;;AAEA;CACC;EACC,kBAAkB;EAClB,WAAW;EACX,qCAAqC;EACrC,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,wBAAgB;EAAhB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,iCAAiC;;CAElC;;CAEA;EACC,QAAQ;EACR,wBAAgB;EAAhB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,qBAAqB;CACtB;;CAEA;EACC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,UAAU;EACV,WAAW;EACX,UAAU;EACV,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,eAAe;EACf,QAAQ;EACR,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,UAAU;EACV,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,8CAA8C;CAC/C;AACD;;AAGA;CACC;EACC,cAAc;CACf;;CAEA;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,oBAAoB;CACrB;AACD","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import '../siteadmin/newcommonstyle.css';\n\n.root {\n\tbackground: var(--background-primary);\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 0px;\n\tmax-width: 100%;\n\tposition: relative;\n\tbackground: var(--background-primary);\n\tborder-bottom: 1px solid var(--primary-border);\n\tz-index: 10;\n}\n\n.fixedHeader {\n\tposition: fixed;\n\twidth: 100%;\n\tleft: 0px;\n\tright: 0px;\n\theight: auto;\n\tmax-height: 100vh;\n}\n\n.commonHeaderBorderLess {\n\tborder: 0px;\n\tbox-shadow: none;\n}\n\n.brand {\n\tline-height: inherit;\n\tvertical-align: middle;\n\ttext-decoration: none;\n\theight: auto;\n\tfloat: left;\n\tpadding: 0px 19px;\n\tcolor: var(--primary-foreground);\n\tfont-size: 24px;\n\tfont-weight: normal;\n}\n\n.brand:hover,\n.brand:focus {\n\ttext-decoration: none;\n\tbackface-visibility: hidden !important;\n}\n\n.navBarToggle {\n\tcolor: var(--primary-foreground);\n\tfloat: right;\n\tfont-size: inherit;\n\tline-height: inherit;\n\tvertical-align: middle;\n\tborder: 0px;\n\tborder-radius: 0px;\n\tmargin: 0px;\n\tpadding: 0px 19px 0px 0px;\n\tbackface-visibility: hidden;\n\theight: 81px;\n\tmargin-right: 10px;\n}\n\n.commonHeaderAdmin {\n\tbackground: #fff;\n\tborder-width: 0px 0px 1px 0px;\n\tborder-color: var(--primary-border);\n\tborder-radius: 0px;\n\tmin-height: 63px;\n\tline-height: 63px;\n\twidth: 100%;\n\tbox-shadow: none;\n\tmargin-bottom: 0px;\n\tz-index: 1001;\n}\n\n.navBarToggle:hover,\n.navBarToggle:focus,\n.navBarToggle:hover:focus {\n\tbackground: none !important;\n}\n\n.listHeaderFixed {\n\tposition: fixed;\n\twidth: 100%;\n\theight: 100vh;\n}\n\n.hamburgerIcon {\n\tfont-size: 20px;\n\tmargin-top: 20px;\n\tfloat: right;\n}\n\n.headerFlexBox {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: space-between;\n\t-ms-flex-pack: space-between;\n\tjustify-content: space-between;\n\tflex-wrap: nowrap;\n\tpadding: 12px 12px 10px;\n}\n\n.homeLogo {\n\theight: 60px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.homeLogo img {\n\twidth: auto;\n\tmax-width: 160px;\n\theight: 100%;\n\tmax-height: 60px !important;\n\tobject-fit: contain;\n\tobject-position: left;\n}\n\n@media screen and (max-width: 1199px) {\n\t.mobileMenu {\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\tbackground: var(--background-primary);\n\t\ttop: 0px;\n\t\theight: auto;\n\t\tz-index: 5;\n\t\tright: -100%;\n\t\ttransition: 0.5s;\n\t\theight: 100vh;\n\t\toverflow-y: auto;\n\t\t-webkit-overflow-scrolling: touch;\n\n\t}\n\n\t.menuOpen {\n\t\tright: 0;\n\t\ttransition: 0.5s;\n\t\toverflow-y: auto;\n\t\toverflow-x: hidden;\n\t\t-webkit-overflow-scrolling: touch;\n\t\theight: 100vh;\n\t\tpadding-bottom: 100px;\n\t}\n\n\t.closeColor {\n\t\tcolor: #0009;\n\t\tfont-size: 36px;\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\ttop: 3px;\n\t\tpadding: 0;\n\t\tright: 22px;\n\t\tz-index: 8;\n\t\tcursor: pointer;\n\t}\n\n\t.closeButtonPosition img {\n\t\twidth: 15px;\n\t\theight: 15px;\n\t}\n\n\t.closeButtonPosition {\n\t\tposition: fixed;\n\t\ttop: 0px;\n\t\twidth: 100%;\n\t\tbackground: var(--background-primary);\n\t\theight: 50px;\n\t\tz-index: 6;\n\t\toverflow: hidden;\n\t}\n\n\t.container {\n\t\tz-index: 10;\n\t}\n\n\t.innerPageHeader {\n\t\tborder-bottom: 1px solid var(--primary-border);\n\t}\n}\n\n\n@media screen and (max-width: 991px) {\n\t.breakPoint {\n\t\tdisplay: block;\n\t}\n\n\t.homeLogo img {\n\t\tmax-width: 100px;\n\t}\n}\n\n@media (max-width: 480px) and (min-width: 320px) {\n\t.mobileMenu {\n\t\tpadding-bottom: 80px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `Header-commonHeaderAdmin-HxV6x`,
	"adminLayout": `Header-adminLayout-UkHJl`,
	"box": `Header-box-hmLxK`,
	"exportLink": `Header-exportLink-k1Sbf`,
	"blockCenter": `Header-blockCenter-Kwex8`,
	"panelHeader": `Header-panelHeader-osu2u`,
	"currencyselect": `Header-currencyselect-YcHY5`,
	"mar0": `Header-mar0-IZ_vp`,
	"root": `Header-root-B1D_e`,
	"container": `Header-container-vreYu`,
	"fixedHeader": `Header-fixedHeader-xOE2l`,
	"commonHeaderBorderLess": `Header-commonHeaderBorderLess-sZPyl`,
	"brand": `Header-brand-uP6rz`,
	"navBarToggle": `Header-navBarToggle-qaw67`,
	"listHeaderFixed": `Header-listHeaderFixed-ozGz6`,
	"hamburgerIcon": `Header-hamburgerIcon-KQAd4`,
	"headerFlexBox": `Header-headerFlexBox-K2PAn`,
	"homeLogo": `Header-homeLogo-QQUBj`,
	"mobileMenu": `Header-mobileMenu-rhJeL`,
	"menuOpen": `Header-menuOpen-I7CV0`,
	"closeColor": `Header-closeColor-mXSsO`,
	"closeButtonPosition": `Header-closeButtonPosition-wr3nK`,
	"innerPageHeader": `Header-innerPageHeader-gfSNO`,
	"breakPoint": `Header-breakPoint-dqTe7`
};
module.exports = ___CSS_LOADER_EXPORT___;
